import { create } from 'zustand';

interface NotesDrawerStore {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
}

export const useNotesDrawerStore = create<NotesDrawerStore>(set => ({
  isOpen: false,

  openDrawer: () => {
    set({ isOpen: true });
  },

  closeDrawer: () => {
    set({ isOpen: false });
  },

  toggleDrawer: () => {
    set(state => ({ isOpen: !state.isOpen }));
  },
}));
